import { Modal, Spin } from "antd";
import React from "react";
import api from "../../URL/axiosConfig";
import ReactJson from "react-json-view";

const ModalLogLastNode = ({ open, setOpen, devEui }) => {
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState({});

  React.useEffect(() => {
    // 1. Definisikan fungsi async DI DALAM useEffect
    const fetchData = async () => {
      if (open) {
        setLoading(true);
        try {
          // Pastikan devEui ada sebelum fetch untuk menghindari error 404/bad request
          if (devEui) {
            let oke = await api({
              url: "/action/cek/node/v2/" + devEui,
            });
            setData(oke.data.data);
          }
        } catch (error) {
          console.error("Error fetching node log:", error);
          setData({});
        } finally {
          // Gunakan finally agar loading false tereksekusi baik sukses maupun gagal
          setLoading(false);
        }
      } else {
        setData({});
      }
    };

    // 2. Panggil fungsi tersebut
    fetchData();

    // 3. Tambahkan devEui ke dependency array agar jika devEui berubah, data di-fetch ulang
  }, [open, devEui]);

  return (
    <Modal
      cancelButtonProps={{
        size: "large",
      }}
      visible={open}
      onCancel={() => setOpen(false)}
      okButtonProps={{ style: { display: "none" } }}
      title="Logs Last Node"
      width={800} // Opsional: Agak diperlebar biar JSON enak dibaca
    >
      <Spin spinning={loading}>
        {/* Style object wrapper agar JSON view tidak terlalu mepet */}
        <div style={{ maxHeight: "60vh", overflow: "auto" }}>
          <ReactJson
            src={data}
            displayDataTypes={false}
            theme="monokai" // Opsional: biar lebih kontras
            collapsed={1} // Opsional: biar tidak terlalu panjang saat awal load
          />
        </div>
      </Spin>
    </Modal>
  );
};

export default ModalLogLastNode;
